import React, { useMemo, useContext } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import routes from "routes";
import TableComponent from "components/widgets/table";
import { ModalContext } from "context/ModalContext";
import AddServiceProvider from "components/widgets/modals/AddServiceProvider";
import { Button } from "react-bootstrap";
import { listServiceProviders, addServiceToPanel } from "services/serviceProviderSrv";
import { useQuery } from "react-query";

const Page = styled.div`
  padding: 32px;
  background: #f8fafc;
  min-height: 100vh;
`;

const Header = styled.div`
  margin-bottom: 32px;
`;

const TitleSection = styled.div`
  margin-bottom: 24px;
`;

const Title = styled.h1`
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #64748b;
  font-weight: 400;
`;

const MetricsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
`;

const MetricCard = styled.div`
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
`;

const MetricLabel = styled.div`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const MetricValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
`;

const ContentCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;

export default function ServiceProviders() {
  const history = useHistory();
  const { modalShow, setModalShow, modalClose } = useContext(ModalContext);

  // Fetch providers
  const {
    data: providers = [],
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["serviceProviders"],
    queryFn: listServiceProviders,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
  });

  // Table configuration
  const tableFields = [
    { name: "Email" },
    { name: "Name" },
    { name: "Category" },
  ];

  const rowData = [
    { type: "text", field: "email" },
    { type: "text", field: "name" },
    { type: "text", field: "category" },
  ];

  console.log(
    "providerss", providers
  )
  // Transform API data → clean table rows
const tableData = useMemo(() => {
  if (!Array.isArray(providers?.data)) return [];

  return providers?.data?.map(item => {
    const sp = item.service_providers?.[0] || {};

    return {
      id: item.id,
      email: sp.serviceProviderPrimaryEmail || "—",
      name: sp.serviceProviderNames || "Unnamed Provider",     // fixed typo: sservice → service
      category: sp.serviceProviderCategory || "Other",
      createdAt: item.createdAt,
      
    };
  });
}, [providers]);

  console.log("tabledata", tableData)
  // Optional: Navigate to provider details
  const viewProvider = (row) => {
    if (row?.id) {
      const target = routes.serviceProviderDetails.replace(":id", row.id);
      history.push(target);
    }
  };

  // Optional: Handle new provider creation (refetch on success)
  const handleCreateProvider = () => {
    refetch(); // Refresh list after adding
    modalClose();
  };

  return (
    <Page>
      <Header>
        <TitleSection>
          <Title>Service Providers</Title>
          <Subtitle>Manage external service providers.</Subtitle>
        </TitleSection>

        <MetricsRow>
          <MetricCard>
            <MetricLabel>Total Providers</MetricLabel>
            <MetricValue>{providers.length}</MetricValue>
          </MetricCard>
        </MetricsRow>

        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
          <Button variant="primary" onClick={() => setModalShow(true)}>
            Add Provider
          </Button>
        </div>
      </Header>

      <ContentCard>
        <TableComponent
          title="Providers"
          table_fields={tableFields}
          table_data={tableData}
          row_data={rowData}
          pageSize={10}
          loading={isLoading}
          onRowClick={viewProvider} // Click row → go to details
        />
      </ContentCard>

      <AddServiceProvider
        show={modalShow}
        onHide={modalClose}
        onCreate={handleCreateProvider}
      />
    </Page>
  );
}